export const REVENUE_SOURCE_COLORS = {
	timeTracking: "#1e3560", // primary-500
	invoiced: "#4398ee", // primary-300
} as const;
